// Frontend/src/app/shared/sidebar/sidebar.component.ts
import { Component, Input } from '@angular/core';
import { Router, RouterLink } from '@angular/router';
import { NzIconDirective } from 'ng-zorro-antd/icon';
import { NzMenuDirective, NzMenuItemComponent } from 'ng-zorro-antd/menu';
import { NzSiderComponent } from 'ng-zorro-antd/layout';
import {NgClass, NgIf} from '@angular/common';
import {AuthService} from '../../services/auth.service';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.css'],
  imports: [NzSiderComponent, NzIconDirective, NzMenuDirective, NzMenuItemComponent, RouterLink, NgIf, NgClass]
})
export class SidebarComponent {
  @Input() isCollapsed: boolean = true;
  @Input() userType: 'admin' | 'cajero' = 'admin';


  constructor(private router: Router, private authService: AuthService) {}

  isActive(route: string): boolean {
    return this.router.url === route;
  }

  logout(): void {
    this.authService.logout();
    this.router.navigate(['/login']);
  }

  toggleSidebar(): void {
    this.isCollapsed = !this.isCollapsed;
  }
}
